import { useEffect } from 'react';
import { useAuth } from '../../authentication/hooks/useAuth';
import { socketService } from '@/features/messaging/api/socketService';

/**
 * Hook for WebSocket connection management
 * 
 * Automatically connects/disconnects WebSocket when component mounts/unmounts.
 * This should be called ONCE at the top level of the messaging feature.
 */
export const useWebSocketConnection = () => {
  const { getAccessToken } = useAuth();

  useEffect(() => {
    const connect = async () => {
      const token = await getAccessToken();
      if (token && !socketService.isConnected()) {
        socketService.connect(token);
      }
    };

    connect();

    return () => {
      socketService.disconnect();
    };
  }, [getAccessToken]);
};

